<template>
  <div class="three-more">
    <div class="three-more__buttons">
      <div
        v-for="(item, index) in buttons"
        :key="`button-${item.id}`"
        class="three-more__button"
      >
        <Button
          :text="item.text"
          :active="index === currentTab"
          @click="handleClickButton(index)"
        />
      </div>
    </div>
    <div class="three-more__items">
      <div
        class="three-more__item"
        v-for="(item, index) in contents"
        :key="`content-${item.id}`"
      >
        <keep-alive :max="3">
          <ThreeMoreContent
            :is-viewport-active="isViewportActive"
            :content="item"
            :key="item.id"
            v-if="index === currentTab"
          />
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
import Button from './Button.vue'
import ThreeMoreContent from './ThreeMoreContent.vue'
export default {
  name: 'ThreeMore',
  components: {
    Button,
    ThreeMoreContent,
  },
  props: {
    isViewportActive: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      currentTab: 0,
      buttons: [
        {
          id: '1',
          text: 'More Viewability',
        },
        {
          id: '2',
          text: 'More Accuracy',
        },
        {
          id: '3',
          text: 'More Vibrance',
        },
      ],
      contents: [
        {
          id: '1',
          headline: `Wide Viewing Angle`,
          subcopy: `Uniform color from horizontal angle (TÜV Certified)`,
          videoUrl: `/theme/rbFront/img/w/magnit/contents/More_1_More Viewability_Wide Viweing Angle.mp4`,
          isEnded: false,
          coverImageUrl: `/theme/rbFront/img/w/magnit/contents/More_1_More Viewability_Wide Viweing Angle.jpg`,
          bodycopy: `In large spaces like control rooms and conference rooms, viewing angle distortion can be an issue. <br>
            However, TÜV-certified LG MAGNIT leverages advanced technology to deliver clear,, vibrant visuals from various angles, ensuring exceptional picture quality and precise color accuracy.`,
          disclimer: `* TUV certification may vary by model. Please consult your sales representative for details.`,
        },
        {
          id: '2',
          headline: `Low Grayscale Image Clarity`,
          subcopy: `Accurate color/brightness expression even in dark scenes (TÜV Certified)`,
          videoUrl: `/theme/rbFront/img/w/magnit/contents/More_2_More Accuracy_Low Grayscale Image Clarity.mp4`,
          isEnded: false,
          coverImageUrl: `/theme/rbFront/img/w/magnit/contents/More_2_More Accuracy_Low Grayscale Image Clarity.jpg`,
          bodycopy: `Video content often includes dark-toned scenes where subtle color differences are hard to perceive. TÜV-certified LG MAGNIT addresses this issue with exceptional grayscale performance, ensuring that even the faintest variations in brightness remain clearly visible.`,
          disclimer: `* TUV certification may vary by model. Please consult your sales representative for details.`,
        },
        {
          id: '3',
          headline: `Deep Black / Vibrant Color Expression`,
          subcopy: `Vivid and clear image quality with LG’s unique black coating technology`,
          videoUrl: `/theme/rbFront/img/w/magnit/contents/More_3_More Vibrance_Deep Black-Vibrant Color Expression.mp4`,
          isEnded: false,
          coverImageUrl: `/theme/rbFront/img/w/magnit/contents/More_3_More Vibrance_Deep Black-Vibrant Color Expression.jpg`,
          bodycopy: `LED displays struggle to portray deep black, but LG MAGNIT overcomes this with innovative chip transfer technology, full black coating, and surface treatment. As a result, even the most intricate shadow details are vividly brought to life, ensuring an unparalleled immersive viewing experience.`,
          disclimer: ``,
        },
      ],
    }
  },
  methods: {
    handleClickButton(i) {
      this.currentTab = i
      this.$emit('click:tab', i)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';

.three-more {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 65px;
  &__buttons {
    display: flex;
    gap: 50px;
    justify-content: center;
  }
  @media screen and (max-width: 1080px) {
    gap: calcQuarter(118);
    &__buttons {
      gap: calcQuarter(32);
    }
  }
}
</style>
